import { NgModule } from '@angular/core'
import { provideConfig } from '@spartacus/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { TRAINING_HEADER_CONVERTER } from './index'
import { TrainingHeaderConverter } from './training-header.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        trainingHeaderFeature: {
          module: () => import('./training-header.module').then((m) => m.TrainingHeaderModule),
          cmsComponents: ['training_header'],
        },
      }
    }),
    {
      provide: TRAINING_HEADER_CONVERTER,
      useExisting: TrainingHeaderConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        training_header: TRAINING_HEADER_CONVERTER
      },
      multi: true
    }
  ]
})
export class TrainingHeaderFeatureModule {
}
